import React, { useState, useCallback, useEffect, useMemo } from 'react';
import styles from './styles.module.css';
import { TransportRegisterByCategoryResponse, CategoryData } from '../api/types';
import { useTranslation } from 'react-i18next';

interface GeneralstatisticstableProps {
  data?: TransportRegisterByCategoryResponse;
}

interface CategoryItem {
  name: string;
  count: number;
  alias: string;
  details: {
    name: string;
    count: number;
  }[];
}

export const Generalstatisticstable: React.FC<GeneralstatisticstableProps> = ({ data }) => {
  const { t, i18n } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedCategory, setExpandedCategory] = useState<string | null>(null);

  const handleSearch = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  }, []);

  const handleCategoryClick = useCallback((alias: string) => {
    setExpandedCategory((prev) => (prev === alias ? null : alias));
  }, []);

  const getCategoryData = useCallback((): CategoryItem[] => {
    if (!data?.res || data.res.length === 0) return [];

    const latestYear = data.res[data.res.length - 1];
    if (!latestYear.categories) return [];

    return latestYear.categories
      .filter((category: CategoryData) => category && category.agriculturalMachineryTypeQuantityAnalytics && category.totalQuantity > 0)
      .map((category: CategoryData) => ({
        name: i18n.language === 'ky'
          ? category.category?.nameKy || category.category?.nameRu || 'Неизвестно'
          : category.category?.nameRu || category.category?.nameKy || 'Неизвестно',
        count: category.totalQuantity || 0,
        alias: category.category?.alias || 'unknown',
        details: (category.agriculturalMachineryTypeQuantityAnalytics || [])
          .filter(item => item && item.transportType)
          .map(item => ({
            name: i18n.language === 'ky'
              ? item.transportType?.nameKy || item.transportType?.nameRu || 'Неизвестно'
              : item.transportType?.nameRu || item.transportType?.nameKy || 'Неизвестно',
            count: item.transportTypeQuantity || 0
          }))
          .filter(item => item.count > 0)
      }))
      .sort((a, b) => b.count - a.count);
  }, [data]);


  const filteredCategories = useMemo(() =>
    getCategoryData().filter(item =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    ),
    [searchTerm, getCategoryData]);

  const totalCount = filteredCategories.reduce((sum, item) => sum + item.count, 0);

  return (
    <div className={styles.container}>
        <h2 className={styles.title}>
            Общие данные
          </h2>
      <div className={styles.tableHeader}>
    

        <div>Техника</div>
        <div>Кол-во</div>
      </div>
      <div style={{ marginTop: '20px', marginBottom: '20px' }}>
        <input
          type="text"
          placeholder="Поиск"
          value={searchTerm}
          onChange={handleSearch}
          className={styles.searchInput}
        />
      </div>
      <div className={styles.tableContent}>
        {filteredCategories.map((item) => (
          <React.Fragment key={item.alias}>
            <div
              className={styles.tableRow}
              onClick={() => handleCategoryClick(item.alias)}
              style={{ cursor: 'pointer' }}
            >
              <div className={styles.techColumn}>
                <span>{item.name}</span>
              </div>
              <div className={styles.count}>{item.count}</div>
            </div>
            {expandedCategory === item.alias && item.details.length > 0 && (
              <div className={styles.detailsContainer}>
                {item.details.map((detail, idx) => (
                  <div key={idx} className={styles.detailRow}>
                    <div className={styles.detailName}>{detail.name}</div>
                    <div className={styles.detailCount}>{detail.count}</div>
                  </div>
                ))}
              </div>
            )}
          </React.Fragment>
        ))}
        {filteredCategories.length > 0 && (
          <div className={styles.totalRow}>
            <div>{t('Total')}</div>
            <div>{totalCount}</div>
          </div>
        )}
      </div>
    </div>
  );
};
